import React from 'react';
import { useHistory, useLocation, useParams, useRouteMatch } from 'react-router-dom';

/**
 * Drop-in replacement for react-router v5 `withRouter`.
 * Wraps a component and injects { navigate, location, params, match } props.
 */
export default function withRouterHOC(Component) {
  function ComponentWithRouterProp(props) {
    const navigate  = useHistory();
    const location  = useLocation();
    const params    = useParams();

    const match     = useRouteMatch(location.pathname);

    return (
      <Component
        {...props}
        history={navigate}
        location={location}
        params={params}
        match={match}
      />
    );
  }

  ComponentWithRouterProp.displayName = `withRouter(${Component.displayName || Component.name})`;
  return ComponentWithRouterProp;
}
